"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SingleSelectFormatter;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

SingleSelectFormatter.propTypes = _propTypes.EditorProps;

function SingleSelectFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column,
      isCellSelected = _ref.isCellSelected,
      rowIdx = _ref.rowIdx;
  var isEditable = column.isEditable;
  var value = row[column.key];

  var handleClick = function handleClick(event) {
    var resolvedAnchorEl = event.currentTarget.getBoundingClientRect();

    var anchorEl = function anchorEl() {
      return {
        nodeType: 1,
        getBoundingClientRect: function getBoundingClientRect() {
          return resolvedAnchorEl;
        }
      };
    };

    column.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        column: column,
        row: row,
        rowIdx: rowIdx,
        openSingleSelectMenu: anchorEl
      });
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex",
    justifyContent: "space-between",
    onClick: isEditable ? !value || isCellSelected ? handleClick : null : null,
    alignItems: "center",
    style: {
      cursor: "pointer",
      height: "100%"
    }
  }, value !== null && value !== void 0 && value.value ? /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
    size: "small",
    color: "primary",
    style: {
      backgroundColor: value.color,
      color: "white"
    },
    label: value.value
  }) : /*#__PURE__*/_react["default"].createElement("div", null), isCellSelected && isEditable && /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null)));
}